module.exports = __webpack_public_path__ + "static/media/sun.2c8984b4.svg";